import { useCallback } from "react"
import { Eye } from "lucide-react"

import BBSwitch from "../../../form/Switch"
import RowOptions from "../../../table/row-options"
import { useLazyFetchSubscriptionsByLeadIdQuery } from "../../../../../redux/queries"
import { LeadLog, SubscriptionDetails } from "../../../../../types"

interface Props {
  info: LeadLog
  onPushToEngagement: (log: LeadLog) => void
  onEnrollToRateAlerts: (subscription?: SubscriptionDetails) => void
}

// Rendered once per row, so nothing here may fetch on mount: the lead's
// subscriptions are only needed inside the menu and load when it opens.
const MenuCell: React.FC<Props> = ({
  info,
  onPushToEngagement,
  onEnrollToRateAlerts
}) => {
  const [fetchSubscriptions, { data: subscriptions }] =
    useLazyFetchSubscriptionsByLeadIdQuery()

  const handleOpenChange = useCallback(
    (open: boolean) => {
      if (open && info.id) {
        fetchSubscriptions({ lead_id: info.id }, true)
      }
    },
    [fetchSubscriptions, info.id]
  )

  const subscription = subscriptions?.[0]

  return (
    <td className="relative whitespace-nowrap py-4 px-0 text-right text-sm font-medium sm:pr-6 pl-3 md: pr-4">
      <RowOptions
        onOpenChange={handleOpenChange}
        actions={[
          {
            label: "Push to subscription",
            icon: Eye,
            onClick: () => onPushToEngagement(info)
          },
          {
            label: (
              <div className="flex items-center justify-between">
                <span className="mr-2">Enroll to rate alerts</span>
                <BBSwitch
                  label=""
                  enabled={subscription?.active === "1"}
                  setEnabled={() => onEnrollToRateAlerts(subscription)}
                />
              </div>
            ),
            onClick: () => false,
            className:
              "border-t border-neutral-200 bg-transparent focus:bg-transparent focus:text-black",
            hidden: !subscription
          }
        ]}
      />
    </td>
  )
}
export default MenuCell
